export type RetuneSelectionCommandState = {
  originalTargetId: string | null;
  updatedTargetId: string;
  originalHz: number;
  updatedHz: number;
};

export type ResolvedRetuneSelectionCommand = {
  targetId: string | null;
  frequencyHz: number;
};

export function resolveRetuneSelectionCommand(
  state: RetuneSelectionCommandState,
  selection: 'original' | 'updated'
): ResolvedRetuneSelectionCommand {
  if (selection === 'original') {
    return {
      targetId: state.originalTargetId,
      frequencyHz: state.originalHz,
    };
  }

  return {
    targetId: state.updatedTargetId,
    frequencyHz: state.updatedHz,
  };
}
